/*
 * Wall Art Landing Page Fixed Scroll Container
 *
 **/

custom.fixedScroll = (() => {
  const breakpoint = 996;
  const targetBlockClass = ".js-fixed-scroll-target";
  const eachChildClass = ".js-fixed-scroll-child";
  const eachDotClass = ".js-fixed-scroll-dot";
  const fixedContainer = ".js-fixed-container";
  let scrollMagicScene;

  function resetAllStyles() {
    $(fixedContainer).css("height", "");
    $(targetBlockClass)
      .find($(eachChildClass).slice(1))
      .removeClass("is-visible");
    $(targetBlockClass)
      .find($(eachDotClass).slice(1))
      .removeClass("slick-active");
  }

  function resetScene() {
    if (scrollMagicScene) {
      scrollMagicScene.remove();
      scrollMagicScene.removePin();
      scrollMagicScene.removeTween();
    }
  }

  function setSceneHeight() {
    $(fixedContainer).css("height", `${window.innerHeight - 64}px`);
  }

  function initScene() {
    const tl = new TimelineMax({
      ease: Linear.easeNone,
    });
    const wrapperHeight = $(targetBlockClass).height();
    const scrollMagicController = new ScrollMagic.Controller();

    $.each($(eachChildClass), (index, el) => {
      if (index == ($(eachChildClass).length - 1)) {
        tl.set($(eachDotClass)[index], { className: "+=slick-active" })
          .set($(el), { className: "+=is-visible" })
          .set($(eachDotClass)[index], { className: "+=slick-active" }, "+=2")
          .set($(el), { className: "+=is-visible" });
      }
      else if (index == 1 && window.innerWidth >= 1025 ) {
        tl.set($(eachDotClass)[index], { className: "+=slick-active" })
          .set($(el), { className: "+=is-visible" })
          .set($(eachDotClass)[index], { className: "-=slick-active" }, "+=5")
          .set($(el), { className: "-=is-visible" });
      }
      else {
        tl.set($(eachDotClass)[index], { className: "+=slick-active" })
          .set($(el), { className: "+=is-visible" })
          .set($(eachDotClass)[index], { className: "-=slick-active" }, "+=2")
          .set($(el), { className: "-=is-visible" });
      }
    });

    scrollMagicScene = new ScrollMagic.Scene({
      triggerElement: targetBlockClass,
      duration: "500%",
      triggerHook: 0.05,
      reverse: true,
    })
    .setPin(targetBlockClass)
    .setTween(tl)
    .addTo(scrollMagicController);

  }


  function initHandler() {
    resetScene();
    resetAllStyles();
    if ($(window).width() >= breakpoint) {
      resetScene();
      resetAllStyles();
      setSceneHeight();
      initScene();
    }
  }

  function init() {
    if ($(targetBlockClass).length > 0) {
      initHandler();
      $(window).on("resize", initHandler);
    }
  }

  return {
    init: init
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/fixed-scroll.js